import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { InsaCronService } from '../../../../insa-services/insa-cron.service';

@Component({
    selector: "copy-job",
    template: require("./copy-job.component.html")
})

export class CopyJobComponent implements OnInit {

    newJobName: string;
    _selectedJobData: any;
    jobNameDuplicate: boolean = false;

    @Input() set selectedJobData(selectedJobData: any) {
        this._selectedJobData = selectedJobData;
    };
    @Input() jobsList = new Array<any>();

    @Output() emitIsComponentCreated: EventEmitter<any> = new EventEmitter<any>(true);

    constructor(private _insaChronosService: InsaCronService){}

    ngOnInit() {}

    onCancel(){
        this.emitIsComponentCreated.emit(false);
    }

    onSubmit(newJobName: any) {
        if(this.jobsList.some(j => j.Name.trim() === newJobName.trim())){
            this.jobNameDuplicate = true;
        }
        else{
            this._insaChronosService.copyJob(newJobName, this._selectedJobData.JobID).subscribe();
            this.emitIsComponentCreated.emit(false);
        }


    }



}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-job-form/copy-job.component.ts